import { render, staticRenderFns } from "./PostCreateForm.vue?vue&type=template&id=0e66a5fc&"
import script from "./PostCreateForm.vue?vue&type=script&lang=js&"
export * from "./PostCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports